import {
  type CalculationFromEnum,
  type PriceListResource,
} from "../../price-list";
import type { ProductResource } from "../../product";
import type { VariantResource } from "../../variant";
import type { VariantComponentResource } from "../../variant-component";

export enum PriceListItemProductType {
  SingleProduct = "single_product",
  ParentProduct = "parent_product",
  Variant = "variant",
  VariantComponent = "variant_component",
}

export enum CalculationType {
  Percent = "percent",
  Fixed = "fixed",
  Absolute = "abs",
  Inactive = "inactive",
}

export enum PriceListItemCalculateType {
  Absolute = "abs",
  Percent = "percent",
  Fixed = "fixed",
  Inactive = "inactive",
}

export interface PriceListItemResource {
  id: string;
  gid: string;
  calculate_from: CalculationFromEnum;
  calculate_value: string;
  calculate_type: PriceListItemCalculateType;
  is_calculate_round: boolean;
  price_listable_type: string;
  price_listable_id: string;
  priceList?: PriceListResource;

  associatedProductResource:
    | ProductResource
    | VariantResource
    | VariantComponentResource;

  product_type: PriceListItemProductType;
}

//   export type StorePriceListRequestBody = {
//     price_list_id: string;
//     price_listable_gid: string;
//     price: number;
//     is_fix_price: boolean;
//     calculation?: {
//       calculate_from?: string;
//       calculate_value?: number;
//       is_calculate_percent?: boolean;
//       is_calculate_round?: boolean;
//       is_calculate_modified?: boolean;
//     };
//   };

//   export type UpdatePriceListRequestBody = {
//     price: number;
//     is_fix_price?: boolean;
//     price_listable_type?: string;
//     price_listable_id?: number;
//     calculation?: {
//       calculate_from: string;
//       calculate_value?: number;
//       is_calculate_percent: boolean;
//       is_calculate_round: boolean;
//       is_calculate_modified: boolean;
//     };
//   };
